const local = "http://localhost:5000";
const live = window.location.origin;
const BASE_URL = window.location.origin

const SECRET_CODE = "enterslice@123";
 

// const API_BASE_URL = live + "/api/v1";
// const API_URL = live;

// const API_BASE_URL = "https://staging.entermark.in/api/public/api";
// const API_BASE_URL = "https://api.entermark.ai/api";
const API_ELSTIC_URL = "https://staging.entermark.in/api";
// const API_ELSTIC_URL = "https://search.entermark.ai/api"; //prod

// const API_ELSTIC_URL = "http://localhost:5000/api"; //local


// const API_BASE_URL = "http://localhost:5001/api";
const API_BASE_URL = "https://stagingv2.entermark.in/api"; // staging
// const API_BASE_URL = "https://searchv2.entermark.ai/api"; // prod
// const API_BASE_URL = "https://api.entermark.in/api";       //Laravel api staging
// const API_BASE_URL = "https://api.entermark.ai/public/api"; //prod
// const API_URL = "https://api.entermark.in";
// const IMG_URl = "https://api.entermark.in/";

/* Where the proposal's "Book a live demo" button sends the reader. Staging and
   production point at different sites, and the link travels inside a PDF that
   outlives the session, so it comes from the environment rather than the host
   the CMS happens to be served from.
     prod    → REACT_APP_DEMO_BASE_URL=https://entermark.ai
     staging → REACT_APP_DEMO_BASE_URL=https://demo.entermark.in */
const DEMO_BASE_URL = "https://entermark.ai";
const DEMO_URL = `${DEMO_BASE_URL.replace(/\/+$/, "")}/request-demo`;

const API_URL = "https://api.entermark.ai";
const IMG_URl = "https://api.entermark.ai/";
// const CLICK_TO_CALL_BASE_URL = "https://enterslice.closecall.in";  //Staging call api
const CLICK_TO_CALL_BASE_URL = "https://crm.closecall.in";  //Prod call api
// const EMAIL_API_URL = "http://localhost:5001";   // email backend local
// const NODE_API_BASE_URL = "http://localhost:5001";
// const EMAIL_API_URL = "http://localhost:5001";   // email backend local
const EMAIL_API_URL = "https://stagingv2.entermark.in"; // staging
// const EMAIL_API_URL = "https://searchv2.entermark.ai"; // prod
const NODE_API_BASE_URL = "https://stagingv2.entermark.in"; // staging
// const NODE_API_BASE_URL = "https://searchv2.entermark.ai"; // prod


export { API_BASE_URL, API_URL, IMG_URl, BASE_URL, API_ELSTIC_URL, SECRET_CODE, CLICK_TO_CALL_BASE_URL, EMAIL_API_URL, NODE_API_BASE_URL, DEMO_URL };
